import { HomePageCard, PageLayout } from "components";
import React from "react";
import config from "config";
import Title from "./title/Title";
import { Stack } from "@mui/material";
import Session from "./Session";
import Calendar from "./Calendar";
import NewsAndUpdates from "./NewsAndUpdates";

function HomePage() {
  return (
    <PageLayout>
      <HomePageCard>
        <Title />
        <Stack>
          <Session />
          <Calendar />
          {config.features.news && <NewsAndUpdates />}
        </Stack>
      </HomePageCard>
    </PageLayout>
  );
}

export default HomePage;
